import React from 'react';
import PropTypes from 'prop-types';

const WorkflowStatus = ({status}) => (
    <span className='badge' style={{background: '#' + status.color}}>
        {status.name}
    </span>
);

WorkflowStatus.propTypes = {
    status: PropTypes.any.isRequired
};

export default WorkflowStatus;
